import styled from 'styled-components';

import Icon from './Icon';

interface RotateIconProps {
  $degrees?: number;
  $initDegrees?: number;
  $rotate?: boolean;
}

const getRotationStr = ({
  $degrees,
  $initDegrees,
  $rotate,
}: RotateIconProps) => {
  const str = $rotate ? `rotate(${$degrees}deg)` : `rotate(${$initDegrees}deg)`;
  return str;
};

const IconRotate = styled(Icon)<RotateIconProps>`
  transform: ${(props) => getRotationStr(props)};
  transition: transform 250ms ease-in-out;
`;

IconRotate.defaultProps = {
  $degrees: 90,
  $initDegrees: 0,
  $rotate: false,
};

export default IconRotate;
